@if (version === 1) {
    @if (lang.routeValue; as src) {
        <vn-icon [name]="src + '-flag'" />
    }

    <span class="lang-label">{{ lang.nativeName }}</span>
} @else {
    @if (displayRadioButton) {
        <ds-radio-group size="large" labelPosition="left" [value]="lang.isActive ? lang.routeValue : ''">
            <ds-radio-button [value]="lang.routeValue" name="options" [checked]="lang.isActive">{{ lang.nativeName }}</ds-radio-button>
        </ds-radio-group>
    }

    @if (!displayRadioButton) {
        <label [attr.for]="lang.routeValue" class="lang-label">{{ lang.nativeName }}</label>
    }
}
